import * as React from 'react';

import { InfoItem } from './InfoItem';
import styles from './InfoLayout.css';
import { TVillageOffersType } from '../../../constants/base';
import { VILLAGE_CLASS_NAMES } from '../../../interfaces/village';
import { TVillageClass } from '../../../types';
import { getYearRange } from '../../../utils/helpers';
import { Card } from '../card';

export interface IInfoLayoutProps {
  finishYearMin?: number;
  finishYearMax?: number;
  villageClass?: TVillageClass;
  total?: number;
  totalOnSale: number;
  offersType: TVillageOffersType | undefined;
}

export class InfoLayout extends React.Component<IInfoLayoutProps> {
  public render() {
    const { finishYearMin, finishYearMax, villageClass, total, totalOnSale, offersType } = this.props;

    return (
      <Card joinBottom dataName="AboutVillage">
        <div className={styles['title']}>О посёлке</div>
        {!!(finishYearMin && finishYearMax) && (
          <InfoItem title="Срок сдачи" value={getYearRange(finishYearMin, finishYearMax)} />
        )}
        {villageClass && villageClass in VILLAGE_CLASS_NAMES && (
          <InfoItem title="Класс" value={VILLAGE_CLASS_NAMES[villageClass]} />
        )}
        {!!total && (
          <>
            {!!offersType && offersType !== 'resale' && <InfoItem title="Объектов" value={total} />}
            {!!offersType && <InfoItem title="В продаже" value={totalOnSale} />}
          </>
        )}
      </Card>
    );
  }
}
